import { faAngleDown, faAngleUp } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { FC, ReactNode } from "react";

import { Typography } from "@aviary";
import { useBreakpoints } from "@shared/hooks";

import * as styles from "./Menu.styles";

interface Props {
  activeItem: string;
  menuItem: string;
  setItem: (chosen: string) => void;
  children?: ReactNode;
}

const Menu: FC<Props> = ({ activeItem, menuItem, setItem, children }) => {
  const { tablet } = useBreakpoints();
  const isMobile = tablet.lessThan;

  const getIcon = () => {
    if (activeItem === menuItem) return <FontAwesomeIcon css={styles.icon} icon={faAngleUp} />;
    return <FontAwesomeIcon css={styles.icon} icon={faAngleDown} />;
  };

  const getStyle = () => {
    if (activeItem === menuItem) return [styles.item, styles.active];
    return styles.item;
  };

  const getMobileStyle = () => {
    if (activeItem === menuItem) return [styles.mobileItem, styles.mobileActive];
    return styles.mobileItem;
  };

  const renderContent = () => {
    if (!isMobile) {
      return (
        <>
          <Typography css={getStyle()} onClick={() => setItem(menuItem)}>
            {menuItem}
            {getIcon()}
          </Typography>
        </>
      );
    }

    return (
      <>
        <div css={styles.menuItem} onClick={() => setItem(menuItem)}>
          <Typography type="h5" css={getMobileStyle()}>
            {menuItem}
          </Typography>
          {getIcon()}
        </div>
        {activeItem === menuItem && children}
      </>
    );
  };

  return renderContent();
};

export { Menu };
